import React, { useState, Children, lazy, Component } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Gift, Paintbrush, ArrowRight } from 'lucide-react';
const FEATURED_ITEMS = [{
  title: "*WHAT'S NEW*",
  href: 'https://www.switchplategallery.com/12m7/what-s-new.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2Fvers1.png',
  description: 'Discover our latest designs and newest arrivals — fresh switchplate styles added regularly to keep your home décor current.',
  icon: Sparkles
}, {
  title: 'GIFT CERTIFICATES',
  href: 'https://www.switchplategallery.com/12m7/gift-certificates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FGift.jpeg',
  description: 'The perfect gift for any home decorator! Let them choose their favorite designs with a Switchplate Gallery gift certificate.',
  icon: Gift
}, {
  title: 'Custom Orders',
  href: '#/custom-orders',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCustom-Orders.png300x300.png',
  description: 'Have a special image or idea in mind? We can create a one-of-a-kind switchplate using your own photo or artwork.',
  icon: Paintbrush
}];
const CATEGORIES = [{
  title: 'Americana Switchplates',
  href: 'https://www.switchplategallery.com/12m7/americana-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FAmericana.jpeg'
}, {
  title: 'Angels & Christian',
  href: 'https://www.switchplategallery.com/12m7/angels-christian.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FAngels.jpeg'
}, {
  title: 'Bath & Outhouses',
  href: 'https://www.switchplategallery.com/12m7/bath-outhouses.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FBath.jpeg'
}, {
  title: 'Beach, Coastal & Palm Trees',
  href: 'https://www.switchplategallery.com/12m7/beach-coastal-palm-trees.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FBeach.jpeg'
}, {
  title: 'Beautiful Scenery & Settings',
  href: 'https://www.switchplategallery.com/12m7/beautiful-scenery-settings.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FBeautifulScenery.jpeg'
}, {
  title: 'Birds--All Kinds!',
  href: 'https://www.switchplategallery.com/12m7/birds-all-kinds.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FBirds.jpeg'
}, {
  title: 'Butterflies, Dragonflies & Bugs',
  href: 'https://www.switchplategallery.com/12m7/butterflies-dragonflies-bugs.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FBugs.jpeg'
}, {
  title: 'Cars and Motorcycles',
  href: 'https://www.switchplategallery.com/12m7/cars-and-motorcycles.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCars.jpeg'
}, {
  title: 'Cat Switch Plates',
  href: 'https://www.switchplategallery.com/12m7/cat-switch-plates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCats.jpeg'
}, {
  title: 'Chef Switchplates',
  href: 'https://www.switchplategallery.com/12m7/chef-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FChef.jpeg'
}, {
  title: 'Christmas, Snowmen, Winter',
  href: 'https://www.switchplategallery.com/12m7/christmas-snowmen-winter.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FChristmas.jpeg'
}, {
  title: 'Classic Art',
  href: 'https://www.switchplategallery.com/12m7/classic-art.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FClassicArt.jpeg'
}, {
  title: 'Coffee & Tea Switchplates',
  href: 'https://www.switchplategallery.com/12m7/coffee-tea-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCoffee%26Tea.jpeg'
}, {
  title: 'Contemporary Switchplates',
  href: 'https://www.switchplategallery.com/12m7/contemporary-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FContemporary.jpeg'
}, {
  title: 'Farm House Switchplates',
  href: 'https://www.switchplategallery.com/12m7/farm-house-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFarm.jpeg'
}, {
  title: 'Cowboys, Southwest and Native American',
  href: 'https://www.switchplategallery.com/12m7/cowboys-southwest-and-native-american.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCowboysSouthwestandNative%20American.jpeg'
}, {
  title: 'Dog Switchplates',
  href: 'https://www.switchplategallery.com/12m7/dog-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FDog.jpeg'
}, {
  title: 'Fairies, Unicorns, Dragons & Mermaids',
  href: 'https://www.switchplategallery.com/12m7/fairies-unicorns-dragons-mermaids.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFairy.jpeg'
}, {
  title: 'Farm Animals, Barns & Tractors',
  href: 'https://www.switchplategallery.com/12m7/farm-animals-barns-tractors.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFarmAnimals.jpeg'
}, {
  title: 'Fashion, Beauty & Boudoir',
  href: 'https://www.switchplategallery.com/12m7/fashion-beauty-boudoir.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFashion.jpeg'
}, {
  title: 'Fire Fighter & Police',
  href: 'https://www.switchplategallery.com/12m7/fire-fighter-police.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFirefighter.jpeg'
}, {
  title: 'Fishing Switch Plate Covers',
  href: 'https://www.switchplategallery.com/12m7/fishing-switch-plate-covers.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFishing.jpeg'
}, {
  title: 'Five Gang Switchplates',
  href: 'https://www.switchplategallery.com/12m7/five-gang-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFive%20Gang%20Switchplates.PNG'
}, {
  title: 'Flower Switchplates',
  href: 'https://www.switchplategallery.com/12m7/flower-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFlower.jpeg'
}, {
  title: 'Folk Art Switch Plates',
  href: 'https://www.switchplategallery.com/12m7/folk-art-switch-plates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFolkArt.jpeg'
}, {
  title: 'French, Italian, German & More Destinations.',
  href: 'https://www.switchplategallery.com/12m7/french-italian-german-more-destinations.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFrench.jpeg'
}, {
  title: 'Frogs, Turtles and Such',
  href: 'https://www.switchplategallery.com/12m7/frogs-turtles-and-such.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFrog.jpeg'
}, {
  title: 'Fruit Switchplates',
  href: 'https://www.switchplategallery.com/12m7/fruit-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFruit.jpeg'
}, {
  title: 'Fun and Nostalgia',
  href: 'https://www.switchplategallery.com/12m7/fun-and-nostalgia.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFunandNostalgia.jpeg'
}, {
  title: 'Golf Light Switch Plates',
  href: 'https://www.switchplategallery.com/12m7/golf-light-switch-plates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FGolf.jpeg'
}, {
  title: 'Halloween',
  href: 'https://www.switchplategallery.com/12m7/halloween.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FHalloween.jpeg'
}, {
  title: 'Horse Switch Plates',
  href: 'https://www.switchplategallery.com/12m7/horse-switch-plates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FHorse.jpeg'
}, {
  title: 'Jungle & Safari Animals',
  href: 'https://www.switchplategallery.com/12m7/jungle-safari-animals.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FJungle%26SafariAnimals.jpeg'
}, {
  title: 'Kids Rooms',
  href: 'https://www.switchplategallery.com/12m7/kids-rooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FKids.jpeg'
}, {
  title: 'Kitchen Switchplates',
  href: 'https://www.switchplategallery.com/12m7/kitchen-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FKitchen.jpeg'
}, {
  title: 'Laundry Room and Sewing',
  href: 'https://www.switchplategallery.com/12m7/laundry-room-and-sewing.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FLaundryRoomandSewing.jpeg'
}, {
  title: 'Leaves and Trees',
  href: 'https://www.switchplategallery.com/12m7/leaves-and-trees.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FLeavesAndTrees.jpeg'
}, {
  title: 'Lighthouse Switchplates',
  href: 'https://www.switchplategallery.com/12m7/lighthouse-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FLighthouse.jpeg'
}, {
  title: 'Man Cave Switchplates',
  href: 'https://www.switchplategallery.com/12m7/man-cave-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FManCave.jpeg'
}, {
  title: 'Movie Themes Switchplates',
  href: 'https://www.switchplategallery.com/12m7/movie-themes-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FMovie.jpeg'
}, {
  title: 'Music and Dance',
  href: 'https://www.switchplategallery.com/12m7/music-and-dance.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FMusic.jpeg'
}, {
  title: 'Nautical Switch Plates',
  href: 'https://www.switchplategallery.com/12m7/nautical-switch-plates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FNautical.jpeg'
}, {
  title: 'Patterns',
  href: 'https://www.switchplategallery.com/12m7/patterns.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FPatterns.jpeg'
}, {
  title: 'Quad Switchplates',
  href: 'https://www.switchplategallery.com/12m7/quad-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FQuad%20Switch%20Plates.PNG'
}, {
  title: 'Roosters & Chickens',
  href: 'https://www.switchplategallery.com/12m7/roosters-chickens.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FRoosters%26Chickens.jpeg'
}, {
  title: 'Seashell Switch Plates',
  href: 'https://www.switchplategallery.com/12m7/seashell-switch-plates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FSeashell.jpeg'
}, {
  title: 'Sports Switchplates',
  href: 'https://www.switchplategallery.com/12m7/sports-switchplates.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FSports.jpeg'
}, {
  title: 'Trains & Planes',
  href: 'https://www.switchplategallery.com/12m7/trains-planes.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FTrains%26Planes.jpeg'
}, {
  title: 'Travel',
  href: 'https://www.switchplategallery.com/12m7/travel.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FTravel.jpeg'
}, {
  title: 'Tropical Fish and Sea Life',
  href: 'https://www.switchplategallery.com/12m7/tropical-fish-and-sea-life.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FTropicalFish.jpeg'
}, {
  title: 'Cabins, Wildlife and Mountains',
  href: 'https://www.switchplategallery.com/12m7/cabins-wildlife-and-mountains.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCabins.jpeg'
}, {
  title: 'Wine & Wine Bottles',
  href: 'https://www.switchplategallery.com/12m7/wine-wine-bottles.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FWine.jpeg'
}, {
  title: 'World Cultures',
  href: 'https://www.switchplategallery.com/12m7/world-cultures.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FWorld.jpeg'
}];
const VISIBLE_COUNT = 24;
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function CategoryGrid() {
  const [showAll, setShowAll] = useState(false);
  const visibleCategories = showAll ? CATEGORIES : CATEGORIES.slice(0, VISIBLE_COUNT);
  return <>
      {/* Shop by Theme */}
      <section id="categories" className="py-20 bg-cream relative" data-id="element-111">
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
        backgroundImage: 'radial-gradient(#2A2522 1px, transparent 1px)',
        backgroundSize: '32px 32px'
      }} data-id="element-112"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-113">
          <div className="text-center mb-14" data-id="element-114">
            <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-gold mb-3" data-id="element-115">
              Browse Our Collection
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-4" data-id="element-116">
              Shop by Theme
            </h2>
            <p className="text-warmGray max-w-xl mx-auto leading-relaxed" data-id="element-117">
              Whatever your decorating theme, we have switchplates to match.
            </p>
          </div>

          <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
          once: true,
          margin: '-80px'
        }} className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5" data-id="element-118">
            {visibleCategories.map((category, idx) => <motion.a href={`#/switchplates?cat=${encodeURIComponent(category.title)}`} key={idx} variants={item} className="group block relative rounded-sm bg-white shadow-warm hover:shadow-warm-lg transition-all duration-300 hover:-translate-y-1" data-id="element-119">
                <div className="aspect-[3/4] overflow-hidden relative rounded-t-sm bg-cream-dark" data-id="element-120">
                  <img src={category.image} alt={category.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out" loading="lazy" data-id="element-121" />
                </div>
                <div className="p-4 md:p-5 bg-white relative z-20 border-t border-warmBorder rounded-b-sm" data-id="element-122">
                  <h3 className="text-sm md:text-base font-serif text-charcoal group-hover:text-gold transition-colors leading-snug mb-1" data-id="element-123">
                    {category.title}
                  </h3>
                  <span className="inline-flex items-center text-gold text-xs font-bold uppercase tracking-wider opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" data-id="element-124">
                    Shop Now <span className="ml-1" data-id="element-125">→</span>
                  </span>
                </div>
              </motion.a>)}
          </motion.div>

          {!showAll && CATEGORIES.length > VISIBLE_COUNT && <div className="text-center mt-16" data-id="element-126">
              <a href="#/switchplates" className="inline-flex items-center px-10 py-4 border-2 border-gold text-gold hover:bg-gold hover:text-white font-bold rounded-sm transition-colors text-sm uppercase tracking-wider" data-id="element-127">
                View All Categories
                <span className="ml-2" data-id="element-128">→</span>
              </a>
            </div>}
        </div>
      </section>

      {/* Featured Section */}
      <section className="py-20 bg-cream-dark relative border-t border-warmBorder" data-id="element-129">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
          <div className="text-center mb-14" data-id="element-131">
            <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-gold mb-3" data-id="element-132">
              Don't Miss
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-4" data-id="element-133">
              New Arrivals, Gifts &amp; Custom Work
            </h2>
            <p className="text-warmGray max-w-xl mx-auto leading-relaxed" data-id="element-134">
              Explore our latest designs, give the perfect gift, or create
              something uniquely yours.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-135">
            {FEATURED_ITEMS.map((featured, idx) => {
            const IconComponent = featured.icon;
            return <motion.a href={featured.title === 'Custom Orders' ? '#/custom-orders' : `#/switchplates?cat=${encodeURIComponent(featured.title)}`} key={idx} initial={{
              opacity: 0,
              y: 24
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: idx * 0.15
            }} className="group block bg-white rounded-sm shadow-warm hover:shadow-warm-lg transition-all duration-300 hover:-translate-y-1 overflow-hidden" data-id="element-136">
                  <div className="aspect-[3/4] overflow-hidden bg-cream-dark relative" data-id="element-137">
                    <img src={featured.image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out" loading="lazy" data-id="element-138" />
                  </div>
                  <div className="p-6 md:p-7 border-t border-warmBorder" data-id="element-139">
                    <div className="flex items-center gap-2 mb-3" data-id="element-140">
                      <IconComponent size={18} className="text-gold" data-id="element-141" />
                      <h3 className="text-lg font-serif text-charcoal group-hover:text-gold transition-colors" data-id="element-142">
                        {featured.title}
                      </h3>
                    </div>
                    <p className="text-warmGray text-sm leading-relaxed mb-4" data-id="element-143">
                      {featured.description}
                    </p>
                    <span className="inline-flex items-center text-gold text-xs font-bold uppercase tracking-wider" data-id="element-144">
                      Explore{' '}
                      <ArrowRight size={14} className="ml-1.5 group-hover:translate-x-1 transition-transform" data-id="element-145" />
                    </span>
                  </div>
                </motion.a>;
          })}
          </div>
        </div>
      </section>
    </>;
}